import FORMS_OF_PAYMENT from '../../scripts/constants/forms-of-payment';
import CreditCardInstallmentsUIModel from './credit-card-installments';

class CreditCardFormOfPaymentUIModel {
  constructor({
    cardCode,
    cardType,
    bankName,
    installments,
    installmentsEMD,
  }) {
    this.class = FORMS_OF_PAYMENT.CREDIT;
    this.cardCode = cardCode;
    this.cardType = cardType;
    this.bankName = undefined;
    this.installments = [];
    this.installmentsEMD = [];

    if (bankName) {
      this.bankName = bankName;
    }

    if (installments) {
      this.installments = installments.map(installment => new CreditCardInstallmentsUIModel(installment));
    }

    this.installments.unshift(new CreditCardInstallmentsUIModel(1));

    if (installmentsEMD) {
      this.installmentsEMD = installmentsEMD.map(installment => new CreditCardInstallmentsUIModel(installment));
    }

    this.installmentsEMD.unshift(new CreditCardInstallmentsUIModel(1));

    this.hasInstallmentsPlan = this.bankName && this.installments && this.installments.length > 0;
  }
}

export default CreditCardFormOfPaymentUIModel;